export default "__VITE_ASSET__Cf4jUhyk__"